import React, { MouseEventHandler } from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import messages from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/messages';
import { translate } from 'containers/services/translate';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { BUTTON_COLORS } from 'constants/design';

export interface FormValidationButtonsProps {
  intl: IntlShape;
  saveForm: MouseEventHandler;
  cancelForm: MouseEventHandler;
  disabled: boolean;
}

export const FormValidationButtons: React.FC<FormValidationButtonsProps> = (
  props,
): JSX.Element => {
  return (
    <section className="submit-add-form">
      <PrimaryButton
        onClick={props.saveForm}
        title={translate(messages.submitForm, props)}
        background={BUTTON_COLORS.PRIMARY_BLUE}
        border={BUTTON_COLORS.PRIMARY_BLUE}
        titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
        disabled={props.disabled}
      />
      <SecondaryButton
        onClick={props.cancelForm}
        title={translate(messages.cancelForm, props)}
      />
    </section>
  );
};

export default injectIntl(FormValidationButtons);
